import { render, staticRenderFns } from "./PriceBulkUpload.vue?vue&type=template&id=4fc7932f&"
import script from "./PriceBulkUpload.vue?vue&type=script&lang=js&"
export * from "./PriceBulkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports